import { filterSongList } from "./filterSongList";
import { initUI } from "./initUI";
export function searchSongListEvent(songHistory, e) {
    const target = e.target;
    if (target.id === "search-known") {
        const songs = filterSongList(target.value.toLowerCase(), songHistory.songs);
        initUI(songHistory, songs);
    }
}
